import { SocialStar } from '@fs/zion-icon'
import { Button, IconButton } from '@fs/zion-ui'
import React from 'react'
import { useTranslation } from 'react-i18next'

type Props = {
  hideText?: boolean
}

export default function FollowActionSkeleton({ hideText }: Props): JSX.Element {
  const [t] = useTranslation()
  const followLabel = t('tree-person.follow.action')

  if (hideText) {
    // eslint-disable-next-line test-selectors/button -- skeleton placeholder
    return <IconButton Icon={SocialStar} title={followLabel} emphasis="low" disabled />
  }
  return (
    // eslint-disable-next-line test-selectors/button -- skeleton placeholder
    <Button Icon={SocialStar} emphasis="low" disabled>
      {followLabel}
    </Button>
  )
}
